module.exports = __webpack_public_path__ + "img/honey.9294982a.png";